import { isEmpty, size } from 'lodash'
import { isValidPhoneNumber } from 'libphonenumber-js'

import helpers from 'helpers'

const isOptional = (value) => {
  if (isEmpty(value) || size(value) <= 3) return true
  return false
}

const schema = ({ value, required = false }) => {
  if (required) {
    if (isEmpty(value)) return false
  } else {
    if (isOptional(value)) return true
  }

  const phoneNumber = helpers.formatters.phone.withPrefix(value)
  return isValidPhoneNumber(phoneNumber)
}

const phone = {
  isOptional,
  schema,
}

export default phone
